import AaSequenceConstants from './AaSequenceConstants';

// Both cases are listed so that characters are checked as given. Uppercasing first is not safe: toUpperCase
// turns some non-ASCII characters into ASCII letters (for example ß into "SS"), which the server then rejects.
const AMINO_ACIDS_ANY_CASE = new Set([
  ...AaSequenceConstants.ALL_AMINO_ACIDS,
  ...AaSequenceConstants.ALL_AMINO_ACIDS.map((aa) => aa.toLowerCase()),
]);

// Validates whether AA sequence is a string composed of elements from amino acid single letter
// abbreviations
function areAminoAcidsValid(aminoAcids: string): boolean {
  return Array.from(aminoAcids).every((aa) => AMINO_ACIDS_ANY_CASE.has(aa));
}

export default areAminoAcidsValid;
